import { render, staticRenderFns } from "./disciplineSg.vue?vue&type=template&id=564cf4a4&"
import script from "./disciplineSg.vue?vue&type=script&lang=js&"
export * from "./disciplineSg.vue?vue&type=script&lang=js&"
import style0 from "./disciplineSg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports